import React from 'react';
import { TaggableResource, TaggableResourcePage, TaggableResourceType } from '~/types/models/tags';
import useResourceTagging from '../../hooks/useResourceTagging';
import { TagBar, TagBarProps } from '../TagBar';

export interface ResourceTagBarProps
  extends Pick<
  TagBarProps,
    | 'emptyText'
    | 'emptyTextClassName'
    | 'tagContainerClassName'
    | 'hideAdditionalTagsCount'
  > {
  resource?: TaggableResource;
  resourceType?: TaggableResourceType;
  className?: string;
  sourcePage: TaggableResourcePage;
  onTagResourceSuccess?: () => void;
  onUnTagResourceSuccess?: () => void;
}

const ResourceTagBar = ({
  resource,
  resourceType,
  className,
  onTagResourceSuccess,
  onUnTagResourceSuccess,
  emptyText,
  emptyTextClassName,
  tagContainerClassName,
  hideAdditionalTagsCount,
  sourcePage
}: ResourceTagBarProps) => {

  const { defaultTags, addTag, deleteTag } = useResourceTagging(
    resource,
    resourceType,
    onTagResourceSuccess,
    onUnTagResourceSuccess,
  );

  return <TagBar
    className={className}
    defaultTags={defaultTags}
    onTagAdd={addTag}
    onTagDelete={deleteTag}
    emptyText={emptyText}
    emptyTextClassName={emptyTextClassName}
    tagContainerClassName={tagContainerClassName}
    hideAdditionalTagsCount={hideAdditionalTagsCount}
    sourcePage={sourcePage}
    resourceType={resourceType}
  />;
};

export default ResourceTagBar;
